export const BLTyp = {
  Brand: 'Brand',
  Normal: 'Normal',
  Shop: 'Shop'
}

export const BLTypeArray = ['Brand', 'Normal', 'Shop']

export const colorList = [
  '#FFCDD2', '#F8BBD0', '#E1BEE7',
  '#D1C4E9', '#C5CAE9', '#BBDEFB',
  '#B3E5FC', '#B2EBF2', '#B2DFDB',
  '#C8E6C9', '#DCEDC8', '#F0F4C3',
  '#FFF9C4', '#FFECB3', '#FFE0B2',
  '#FFCCBC', '#D7CCC8', '#CFD8DC',
  '#FFFFFF'
]

export const UserBLAuth = {
  DataCenter: 'DataCenter',
  Inventory: 'Inventory',
  Supplier: 'Supplier',
  Admin: 'Admin',
  Subscription: 'Subscription',
  Owner: 'Owner'
}
